module.exports = __webpack_public_path__ + "img/img_target_left_af.61b358d8.svg";